    <div class="container-fluid">

    <app-page-header header="{{pageTitle}}" description="{{pageSubTitle}}">
    </app-page-header>
<div class="release-main-container">
    <div class="release-toolbar-row">
        <p class="release-title">
            Release: {{releaseName}}
        </p>
        <!-- <div class="release-search-container">
            <mat-icon class="release-search-icon">
                search
            </mat-icon>
            <input type="text" class="release-search-input" placeholder="Search by Action Name"
                [value]="quickFilterValue" (input)="onQuickFilterChanged($event)" />
        </div> -->
        <button mat-icon-button class="refresh-btn" (click)="refreshTable()">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
    
    <div id="release-status">
    <!-- for agGrid height: 625px;  -->
        <ag-grid-angular #agGrid  [style]="styleChipDiv"[rowData]="filteredRowData" [columnDefs]="columnDefs"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate" [infiniteInitialRowCount]="infiniteInitialRowCount"
            class="ag-theme-material"  [defaultColDef]="defaultColDef"
            [suppressMenuHide]="false" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>
</div>